<template>
  <div
    v-loading="loading"
    class="mobile-page"
    :class="{ 'is-mobile': isMobile }"
  >
    <!-- 移动端头部 -->
    <div
      v-if="isMobile"
      class="mobile-header"
    >
      <h2 class="mobile-title">
        消防维保信息查询
      </h2>
      <!-- 临时状态指示器 -->
      <!-- <div style="font-size: 10px; color: #999; text-align: center; margin-top: 5px;">
        滚动检测: {{ scrollStatus }} | 设备: {{ isMobile ? '移动端' : 'PC端' }}
      </div> -->
    </div>

    <!-- PC端头部 -->
    <div
      v-else
      class="l-page__header c-page__header"
    >
      <h2 class="c-page__header-title">
        {{ dlTypeStr }}
      </h2>
      <div class="c-page__header-btns">
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="refreshSearch()"
        >
          查询
        </el-button>
      </div>
    </div>

    <!-- 移动端内容 -->
    <div
      v-if="isMobile"
      class="mobile-content"
    >
      <div
        v-if="page.rows.length === 0 && !loading"
        class="mobile-empty"
      >
        <p>暂无相关维保信息</p>
      </div>
      <div
        v-else
        class="mobile-list"
      >
        <div
          v-for="(item, index) in page.rows"
          :key="index"
          class="mobile-card"
        >
          <div class="card-header">
            <h3 class="project-name">
              {{ item.xmmc }}
            </h3>
          </div>
          <div class="card-content">
            <div class="info-item">
              <span class="label">计划名称：</span>
              <span class="value">{{ item.jhmc }}</span>
            </div>
            <div class="info-item">
              <span class="label">报告：</span>
              <span
                class="report-link"
                :class="{ 'downloading': item.previewPdf }"
                @click="downloadReport(item)"
              >
                <i
                  v-show="item.previewPdf"
                  class="el-icon-loading"
                />
                {{ item.bgbh }}
              </span>
            </div>
            <!--  <div class="info-item">
              <span class="label">状态：</span>
              <span class="value">{{ item.jhztMc }}</span>
            </div>
            <div class="info-item">
              <span class="label">所属区域：</span>
              <span class="value">{{ item.areaMc }}</span>
            </div> -->
          </div>
        </div>
      </div>

      <!-- 移动端加载状态 -->
      <div
        v-if="isMobile && loading && page.rows.length > 0"
        class="mobile-loading"
      >
        <div class="loading-spinner">
          <i class="el-icon-loading" />
          <span>加载中...</span>
        </div>
      </div>

      <!-- 移动端无更多数据提示 -->
      <div
        v-if="isMobile && !loading && !page.hasNext && page.rows.length > 0"
        class="mobile-no-more"
      >
        <p>已显示全部数据</p>
      </div>
    </div>

    <!-- PC端内容 -->
    <div
      v-else
      class="pc-content"
    >
      <div class="l-page__item l-page--search__item">
        <el-card
          class="c-card--condition"
          shadow="never"
        >
          <div
            slot="header"
            class="clearfix"
          >
            <span>查询条件</span>
          </div>
          <el-form
            ref="filterParams"
            class="c-form c-condition__form"
            :model="filterParams"
            :inline="true"
            label-position="right"
            label-width="80px"
            label-suffix="："
          />
        </el-card>
      </div>

      <div class="l-page__body l-page--search__body">
        <el-tabs
          type="border-card"
          class="l-page__tabs l-page__tabs--single"
        >
          <el-tab-pane label="查询结果">
            <el-table
              ref="elTable"
              height="100%"
              :data="page.rows"
              stripe
              border
            >
              <el-table-column
                type="index"
                label="序号"
                width="60"
                align="center"
              />
              <el-table-column
                label="报告编号"
                min-width="120"
                align="left"
              >
                <template slot-scope="scope">
                  <el-link
                    type="primary"
                    :disabled="scope.row.previewPdf"
                    @click="downloadReport(scope.row)"
                  >
                    <i
                      v-show="scope.row.previewPdf"
                      class="el-icon-loading"
                    />
                    {{ scope.row.bgbh }}
                  </el-link>
                </template>
              </el-table-column>
              <el-table-column
                prop="xmmc"
                label="项目名称"
                min-width="140"
                align="left"
              />
              <el-table-column
                prop="jhmc"
                label="计划名称"
                min-width="100"
                align="left"
              />
            </el-table>

            <!-- PC端分页组件 -->
            <div
              v-if="page.total > 0"
              class="pc-pagination"
            >
              <el-pagination
                :current-page="page.pageNo"
                :page-sizes="[10, 15, 20, 50]"
                :page-size="page.pageSize"
                :total="page.total"
                layout="total, sizes, prev, pager, next, jumper"
                @size-change="handleSizeChange"
                @current-change="search"
              />
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import { bgglService } from './bggl.service';
import config from '@/config';

export default {
  name: 'JcsjtsIndex',
  components: {
  },

  data () {
    return {
      loading: false, // 页面是否loading状态
      isMobile: false, // 是否移动端
      windowWidth: window.innerWidth, // 窗口宽度
      isLoadingMore: false, // 是否正在加载更多
      scrollTimer: null, // 滚动节流定时器
      lastLoadTime: 0, // 上次加载时间
      scrollStatus: '等待', // 滚动状态显示
      lwdws: [], // 联网单位
      /* 查询条件（页面绑定的查询条件） start */
      filterParams: {
        xmId: null,
        bgbh: null, // 报告编号
        jhmc: null, // 计划名称
        xmmc: null, // 项目名称
        bgType: 'XFWBSYBG',
        bglx: ['DGZ', 'DQZ', 'YQZ', 'YGZ', 'YFB'] // 计划状态代码
      },
      /* 查询条件 end */

      /* 分页实际查询条件（避免查询条件的双向绑定导致点击分页按钮，获取到的数据不符合真实过滤条件） Start */
      trueFilterParams: {},
      /* 分页实际查询条件 End */

      /* 查询结果 Start */
      page: {
        rows: [],
        total: 0,
        pageSize: 15,
        pageNo: 0
      },
      /* 查询结果 End */

      /* 弹窗 Start */
      showDialogName: '',
      dialogParams: {}
      /* 弹窗 End */

    };
  },
  computed: {
    /** 动态获取路由名称 */
    dlType () {
      return this.$route.name;
    },
    dlTypeStr () {
      return this.$route.meta && this.$route.meta.navtabTitle ? this.$route.meta.navtabTitle : '消防维保信息查询';
    },
    currentUrl () {
      return window.location.href;
    }
  },
  methods: {
    /**
     * @description: 检测是否为移动端
     */
    checkMobile () {
      const userAgent = navigator.userAgent;

      // 更新窗口宽度
      this.windowWidth = window.innerWidth;

      // 检查URL参数是否强制移动端模式
      const urlParams = new URLSearchParams(window.location.search);
      const forceMobile = urlParams.get('mobile');

      if (forceMobile === 'true' || forceMobile === '1') {
        // 强制移动端模式（用于在PC端测试手机效果）
        this.isMobile = true;
      } else {
        // 正常的设备检测逻辑
        this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent) ||
                        window.innerWidth <= 768;
      }

      // 移动端时调整分页大小
      if (this.isMobile) {
        this.page.pageSize = 5; // 移动端每页5条
      } else {
        this.page.pageSize = 15; // PC端每页15条
      }
    },

    /**
     * @description: 从URL获取xmId参数
     */
    getXmIdFromUrl () {
      let xmId = null;

      // 方法1: 从URL search参数获取
      const urlParams = new URLSearchParams(window.location.search);
      xmId = urlParams.get('xmId');

      // 方法2: 从hash中的参数获取（适配微信开发者工具）
      if (!xmId && window.location.hash) {
        const hashParts = window.location.hash.split('?');
        if (hashParts.length > 1) {
          const hashParams = new URLSearchParams(hashParts[1]);
          xmId = hashParams.get('xmId');
        }
      }

      // 方法3: 从Vue Router的query参数获取
      if (!xmId && this.$route && this.$route.query && this.$route.query.xmId) {
        xmId = this.$route.query.xmId;
      }

      if (xmId) {
        this.filterParams.xmId = xmId;
      }
    },

    /**
     * @description: 下载报告PDF
     */
    downloadReport (item) {
      if (item.bgUrl) {
        // 设置下载状态
        this.$set(item, 'previewPdf', true);

        // 检测是否为移动端
        const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

        if (isMobileDevice) {
          // 移动端：直接使用后端URL在新标签页打开
          const { iffApi } = config.ctx;
          const directUrl = `${iffApi}/noauth/common/wbbg/${item.bgUrl}`;

          const newWindow = window.open(directUrl, '_blank');
          if (newWindow) {
            this.$message({
              message: '正在浏览器中打开PDF文件，您可以选择查看或下载',
              type: 'success',
              duration: 3000
            });
          } else {
            // 如果弹窗被阻止，尝试直接下载
            bgglService.downloadWbbgPdf(item.bgUrl)
              .then(response => {
                const blob = new Blob([response.data], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `消防维护维保报告_${item.bgbh || item.bgUrl}.pdf`;
                link.style.display = 'none';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                setTimeout(() => {
                  window.URL.revokeObjectURL(url);
                }, 1000);

                this.$message({
                  message: '浏览器阻止了弹窗，已为您下载文件到本地',
                  type: 'warning',
                  duration: 4000
                });
              })
              .catch(error => {
                console.error('下载PDF出错:', error);
                this.$message.error('下载失败，请稍后重试');
              });
          }

          // 移动端直接结束，不需要blob处理
          this.$set(item, 'previewPdf', false);
          return;
        }

        // PC端：使用blob方式
        bgglService.downloadWbbgPdf(item.bgUrl)
          .then(response => {
            // 创建blob URL
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);

            // PC端：在新窗口中打开PDF文件
            const newWindow = window.open(url, '_blank');
            if (newWindow) {
              // 设置窗口标题（某些浏览器支持）
              setTimeout(() => {
                try {
                  newWindow.document.title = `消防维护维保报告_${item.bgbh || item.bgUrl}`;
                } catch (e) {
                  // 跨域限制，忽略错误
                }
              }, 100);

              this.$message.success('报告打开成功');

              // 延迟释放URL，确保新窗口加载完成
              setTimeout(() => {
                window.URL.revokeObjectURL(url);
              }, 3000);
            } else {
              // 如果弹窗被阻止，提供下载链接
              const link = document.createElement('a');
              link.href = url;
              link.download = `消防维护维保报告_${item.bgbh || item.bgUrl}.pdf`;
              link.style.display = 'none';
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
              this.$message.warning('浏览器阻止了弹窗，已为您下载文件');
            }
          })
          .catch(error => {
            console.error('下载PDF出错:', error);
            this.$message.error('下载失败，请稍后重试');
          })
          .finally(() => {
            this.$set(item, 'previewPdf', false);
          });
      } else {
        this.$message.warning('暂无报告文件');
      }
    },

    /**
     * @description: 移动端加载更多数据
     */
    loadMore () {
      const now = Date.now();
      // 设置2秒的冷却时间，防止频繁触发
      if (now - this.lastLoadTime < 2000) {
        return;
      }

      if (this.page.hasNext && !this.loading && !this.isLoadingMore) {
        this.lastLoadTime = now;
        this.isLoadingMore = true;
        this.search(this.page.nextPage);
      }
    },

    /**
     * @description: 滚动事件处理
     */
    handleScroll () {
      if (!this.isMobile) {
        this.scrollStatus = 'PC端不检测';
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      const documentHeight = Math.max(
        document.body.scrollHeight,
        document.body.offsetHeight,
        document.documentElement.clientHeight,
        document.documentElement.scrollHeight,
        document.documentElement.offsetHeight
      );

      const distanceToBottom = documentHeight - (scrollTop + windowHeight);
      this.scrollStatus = `距底部 ${Math.round(distanceToBottom)}px`;

      // 检查是否满足加载条件
      if (this.loading || this.isLoadingMore || !this.page.hasNext) {
        this.scrollStatus += ' (暂停)';
        return;
      }

      // 当滚动到距离底部50px时触发加载（接近底部才触发）
      if (distanceToBottom <= 50) {
        this.scrollStatus = '触发加载!';
        this.loadMore();
      }
    },

    /**
     * @description: 节流版本的滚动处理
     */
    throttledScroll () {
      if (!this.isMobile) {
        return;
      }

      if (this.scrollTimer) {
        clearTimeout(this.scrollTimer);
      }
      this.scrollTimer = setTimeout(() => {
        this.handleScroll();
      }, 300);
    },

    handleDialog (_name, _parmas) {
      this.showDialogName = _name;
      this.dialogParams = _parmas;
    },

    /**
     * @description: 记录分页查询条件，调用查询方法
     * @return {*}
     */
    refreshSearch () {
      this.trueFilterParams = JSON.parse(JSON.stringify(this.filterParams));
      this.search();
    },
    /**
     * @description: 查询列表方法
     * @param {number} _pageNo
     * @return {*}
     */
    search (_pageNo = 1) {
      /* 处理分页参数 Start */
      this.trueFilterParams.pageSize = this.page.pageSize;
      this.trueFilterParams.pageNo = _pageNo;
      /* 处理分页参数 End */

      this.loading = true;

      bgglService.getWbbgCommon(this.trueFilterParams)
        .then(rsp => {
          // 移动端分页加载：追加数据
          if (this.isMobile && _pageNo > 1) {
            // 追加新数据到现有数据
            this.page.rows = [...this.page.rows, ...rsp.data.rows];
            // 更新分页信息
            this.page.total = rsp.data.total;
            this.page.pageNo = rsp.data.pageNo;
            this.page.totalPages = rsp.data.totalPages;
            this.page.hasNext = rsp.data.hasNext;
            this.page.nextPage = rsp.data.nextPage;
          } else {
            // PC端或首次加载：替换数据
            this.page = Object.assign({}, this.page, rsp.data);
          }

          // 导出条件更新为查询使用的条件
          this.exportFilterParams = JSON.parse(JSON.stringify(this.trueFilterParams));
        })
        .catch(err => {
          console.error('查询错误！', err);
        })
        .finally(() => {
          this.loading = false;
          this.isLoadingMore = false;
        });
    },
    /**
     * @description: 分页切换大小
     * @param {number} val
     * @return {*}
     */
    handleSizeChange (val) {
      this.page.pageSize = val;
      this.search();
    },
    /**
     * @description: 重置页面为初始状态
     * @param：
     * @return {*}
     */
    resetForm () {
      this.$refs.filterParams.resetFields();
    }
  },
  created () {
    // 处理 preloading 元素不存在的情况
    const preloadingEl = document.getElementById('preloading');
    if (preloadingEl) {
      preloadingEl.style.display = 'none';
    }

    // 检测移动端
    this.checkMobile();
    // 获取URL参数
    this.getXmIdFromUrl();

    // 执行查询
    this.refreshSearch();
  },
  mounted () {
    // 监听窗口大小变化
    window.addEventListener('resize', this.checkMobile);
    // 监听滚动事件（用于移动端上划加载）
    window.addEventListener('scroll', this.throttledScroll, { passive: true });

    // 移动端特殊处理：监听触摸事件
    if (this.isMobile) {
      document.addEventListener('touchmove', this.throttledScroll, { passive: true });
      document.addEventListener('touchend', this.throttledScroll, { passive: true });
    }
  },
  beforeDestroy () {
    // 清除定时器
    if (this.scrollTimer) {
      clearTimeout(this.scrollTimer);
    }
    // 移除监听器
    window.removeEventListener('resize', this.checkMobile);
    window.removeEventListener('scroll', this.throttledScroll);

    // 移除移动端触摸事件监听
    if (this.isMobile) {
      document.removeEventListener('touchmove', this.throttledScroll);
      document.removeEventListener('touchend', this.throttledScroll);
    }
  },
  activated () {
    if (this.$route.params.isRefresh) {
      this.refreshSearch();
    }
  }
};
</script>

<style scoped lang="scss">
/* 调试样式 - 确保页面可见 */
.mobile-page {
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
}

.mobile-page {
  background-color: #f5f5f5;
  max-width: 100%;
  overflow-x: hidden; // 防止横向滚动
  height: auto; // 确保高度自适应内容
  min-height: 100vh; // 最小高度100vh

  &.is-mobile {
    .pc-content {
      display: none;
    }
  }

  &:not(.is-mobile) {
    .mobile-header,
    .mobile-content {
      display: none;
    }
  }
}

/* 移动端样式 */
.mobile-header {
  background: #ffffff;
  padding: 15px 20px;
  border-bottom: 1px solid #e6e6e6;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  .mobile-title {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #333;
    text-align: center;
  }
}

.mobile-content {
  padding: 15px;
  max-width: 100%;
  box-sizing: border-box;
  min-height: calc(100vh - 120px); // 确保有足够高度触发滚动，减去header高度
}

.mobile-empty {
  text-align: center;
  padding: 60px 20px;
  color: #999;

  p {
    margin: 0;
    font-size: 16px;
  }
}

.mobile-list {
  width: 100%;
  max-width: 100%;

  .mobile-card {
    background: #ffffff;
    border-radius: 8px;
    margin-bottom: 15px;
    padding: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    border: 1px solid #e6e6e6;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;

    .card-header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin-bottom: 12px;
      padding-bottom: 12px;
      border-bottom: 1px solid #f0f0f0;

      .project-name {
        margin: 0;
        font-size: 16px;
        font-weight: 600;
        color: #333;
        line-height: 1.4;
        flex: 1;
        margin-right: 10px;
      }

      .report-number {
        font-size: 12px;
        color: #666;
        background: #f8f9fa;
        padding: 4px 8px;
        border-radius: 4px;
        white-space: nowrap;
      }
    }

    .card-content {
      .info-item {
        display: flex;
        margin-bottom: 8px;
        font-size: 14px;

        &:last-child {
          margin-bottom: 0;
        }

        .label {
          color: #666;
          min-width: 80px;
          flex-shrink: 0;
        }

        .value {
          color: #333;
          flex: 1;
          word-break: break-all;
        }

        .report-link {
          color: #409eff;
          cursor: pointer;
          flex: 1;
          word-break: break-all;
          text-decoration: underline;
          transition: color 0.3s;

          &:hover {
            color: #66b1ff;
          }

          &:active {
            color: #3a8ee6;
          }

          &.downloading {
            color: #999;
            cursor: not-allowed;
          }

          .el-icon-loading {
            margin-right: 4px;
          }
        }
      }
    }

    .card-actions {
      margin-top: 12px;
      padding-top: 12px;
      border-top: 1px solid #f0f0f0;
      text-align: right;

      .action-btn {
        padding: 8px 16px;
        border: none;
        border-radius: 4px;
        font-size: 14px;
        cursor: pointer;
        transition: all 0.3s;

        &.primary {
          background: #409eff;
          color: white;

          &:hover {
            background: #66b1ff;
          }

          &:active {
            background: #3a8ee6;
          }
        }
      }
    }
  }
}

/* 移动端加载状态样式 */
.mobile-loading {
  padding: 20px 15px;
  text-align: center;

  .loading-spinner {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 14px;

    .el-icon-loading {
      margin-right: 8px;
      font-size: 16px;
      animation: rotating 2s linear infinite;
    }

    span {
      color: #666;
    }
  }
}

@keyframes rotating {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.mobile-no-more {
  padding: 20px;
  text-align: center;
  color: #999;
  font-size: 14px;

  p {
    margin: 0;
    position: relative;

    &::before,
    &::after {
      content: '';
      position: absolute;
      top: 50%;
      width: 60px;
      height: 1px;
      background: #e6e6e6;
    }

    &::before {
      left: -80px;
    }

    &::after {
      right: -80px;
    }
  }
}

/* PC端样式保持不变 */
.pc-content {
  .o-tips {
    position: absolute;
    top: 4px;
    right: 12px;
    z-index: 9;
    padding-left: 8px;
    border-left: 0;
    color: #f56c6c;
    background-color: #fef0f0;
  }

  .pc-pagination {
    margin-top: 20px;
    text-align: right;
  }
}

/* 响应式调整 */
@media (max-width: 768px) {
  .mobile-page:not(.is-mobile) {
    .mobile-header,
    .mobile-content {
      display: block;
    }

    .pc-content {
      display: none;
    }
  }
}
</style>

<style lang="scss">
/* 非scoped样式 - 确保页面可以滚动 */
html, body {
  overflow-y: auto !important;
  height: auto !important;
  min-height: 100vh !important;
  -webkit-overflow-scrolling: touch; // iOS平滑滚动
}

#app {
  overflow-y: auto !important;
  height: auto !important;
  min-height: 100vh !important;
}

/* 移动端滚动优化 */
@media (max-width: 768px) {
  html, body {
    touch-action: pan-y !important; // 允许垂直滚动
    -webkit-overflow-scrolling: touch !important;
  }

  .mobile-page {
    touch-action: pan-y !important;
    -webkit-overflow-scrolling: touch !important;
  }

  .mobile-content {
    touch-action: pan-y !important;
    -webkit-overflow-scrolling: touch !important;
  }
}
</style>
